import { DataBean } from "../DataBean";

export class ProcessImported extends DataBean {



    public async processImportedEmployeeFactors(idPayrollType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_processImportedEmployeeFactors_Number", [idPayrollType]);
    }

}
